import React, { useState } from 'react';
import './Login.css';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      // Make POST request to the login endpoint
      await fetch('https://tag-onsite-dynamic-team-staging.eu-west-1.csq.io/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      }).catch(err => {
        // Silently catch any network errors
        console.log('Network request failed, but proceeding with login anyway:', err);
      });

      // Always simulate successful login after a short delay
      setTimeout(() => {
        setIsLoading(false);
        onLogin(); // Redirect to main app
      }, 500); // Small delay for UX

    } catch (err) {
      // Even if there's an error, we'll still log in
      console.log('Error ignored, proceeding with login anyway:', err);
      setTimeout(() => {
        setIsLoading(false);
        onLogin(); // Redirect to main app
      }, 500);
    }
  };


  return (
    <div className="login-container">
      <script
        type="text/javascript"
        dangerouslySetInnerHTML={{
          __html: `
            window._uxa = window._uxa || [];
            window._uxa.push(["trackDynamicVariable", { key: "login", value: "login_value" }]);
          `
        }}
      />
      <div className="login-form-container">
        <h1>Login</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              disabled={isLoading}
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              disabled={isLoading}
            />
          </div>
          <button type="submit" className="login-button" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
